import axios from 'axios'
const state = {
    loading: false,
    variables: [],
};
const getters = {
    getLoadingStatus(state) {
        return state.loading;
    },
    getVariables(state) {
        return state.variables
    },
};

const mutations = {
    setLoadingStatus(state, status) {
        state.loading = status;
    },
    setVariables(state, variables) {
        state.variables = variables
    },
};

const actions = {
    async fetchVariables({ commit }, queryParams) {
        try {
            commit('setLoading', true)
            let params = {};
            for (let key in queryParams) {
                if (queryParams[key]) {
                    params[key] = queryParams[key];
                }
            }
            if(!queryParams.paginated) params.paginated = queryParams.paginated;
            const response = await axios.get("/school-variable", {
                params,
            });
            commit('setVariables', response.data.data)
            
        } catch (err) {
            console.log('err', err);
        } finally {
            commit('setLoading', false)
        }
    },
}

export default {
    state,
    getters,
    mutations,
    actions,
    namespaced: true
}